import * as wjcCore from '@grapecity/wijmo';
import * as wjMultirow from '@grapecity/wijmo.grid.multirow';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import * as wjInput from 'wijmo/wijmo.input';
import * as wjOlap from '@grapecity/wijmo.olap';
import * as moment from "moment";

'use strict';

import {ViewChild, Component, AfterViewInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {ToasterService} from "angular2-toaster";
import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {asOrientDate, isOrientDate, DataService} from "@cosbeni/database";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'cj-user-measure-analysis',
    templateUrl: 'measure-analysis.component.html',
})

export class MeasureAnalysisComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('measureGrid') measureGrid: wjMultirow.MultiRow;
    @ViewChild('pivotGrid', {static: true}) pivotGrid: wjOlap.PivotGrid;
    @ViewChild('fromDateInput') fromDateInput: wjInput.InputDate;
    @ViewChild('toDateInput') toDateInput: wjInput.InputDate;
    fromDate: any;
    toDate: any;
    keyword: string = "";
    message: string = "";
    screenWidth: number;
    carts: any = {};
    measures: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    pivot: wjOlap.PivotEngine;

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private route: ActivatedRoute) {
        var today = new Date();
        this.fromDate= new Date(today.getFullYear(), today.getMonth(), 1);
        this.toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        this.dataService.query({
            sql: "SELECT FROM AP_Master WHERE category ='カゴ車' order by sort",
            count:  "SELECT FROM AP_Master WHERE category ='カゴ車' order by sort",
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                for(let cart of data.results){
                    if(wjcCore.isNumber(cart.weight)){
                        this.carts[cart.value] = cart.weight;
                    } else {
                        this.carts[cart.value] = 0;
                    }
                }
            }
        })
    }

    ngAfterViewInit() {
        this.toDateInput.min = this.fromDate;
    }

    search(): void {
        let where = [];
        if (!wjcCore.isNullOrWhiteSpace(this.keyword)) {
            where.push("memo LIKE '%" + this.keyword + "%'");
        }
        if (wjcCore.isDate(this.fromDate) && wjcCore.isDate(this.toDate)) {
            where.push("(measureDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "' AND measureDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "')");
        } else {
            if (wjcCore.isDate(this.fromDate)) {
                where.push("measureDate >= '" + wjcCore.Globalize.formatDate(this.fromDate, 'yyyy-MM-dd HH:mm:ss') + "'");
            }
            if (wjcCore.isDate(this.toDate)) {
                where.push("measureDate < '" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.toDate, 1), 'yyyy-MM-dd HH:mm:ss') + "'");
            }
        }
        this.dataService.query({
            sql: "SELECT FROM AP_Measure WHERE " + where.join(" OR "),
            count: "SELECT FROM AP_Measure WHERE " + where.join(" OR "),
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            for(let item of data.results){
                if (isOrientDate(item.measureDate)) {
                    item.measureDate = asOrientDate(item.measureDate);
                }
            }
            let clothes = {};
            let measures = [];
            for(let item of data.results){
               let measure = {
                   '番号': item.id,
                   '計量日': item.measureDate,
                   '部門': item.department,
                   '対象': item.measureType,
                   'カゴ車': item.cart,
                   '粗重量': item.weight,
                   '重量': item.weight - this.carts[item.cart],
                   'メモ': item.memo
               }
               measures.push(measure);
               let multiplier = -1.0;
               if(item.measureType == "総重量"){
                   multiplier = 1.0
               }
               if(!clothes.hasOwnProperty(item.measureDate)){
                   clothes[item.measureDate] = {}
               }
                if(!clothes[item.measureDate].hasOwnProperty(item.department)){
                    clothes[item.measureDate][item.department] = 0;
                }
               clothes[item.measureDate][item.department] = clothes[item.measureDate][item.department] + (item.weight - this.carts[item.cart])* multiplier;
            }
            let measureDates: any[] = Object.keys(clothes);
            measureDates.forEach((measureDate: any) => {
                let departments: any[] = Object.keys(clothes[measureDate]);
                departments.forEach((department: any) => {
                    let measure = {
                        '番号': 0,
                        '計量日': moment(measureDate).toDate(),
                        '部門': department,
                        '対象': "服",
                        'カゴ車': "",
                        '粗重量': clothes[measureDate][department],
                        '重量': clothes[measureDate][department],
                        'メモ': ""
                    }
                    measures.push(measure);
                })
            });
            this.measures = new wjcCore.CollectionView(wjcCore.asArray(measures));
            this.pivot = new wjOlap.PivotEngine(
                {
                    autoGenerateFields: false,
                    itemsSource: this.measures,
                    showRowTotals: wjOlap.ShowTotals.Subtotals,
                    showColumnTotals: wjOlap.ShowTotals.None,
                    fields: [
                        {binding: '番号', header: '番号'},
                        {binding: '計量日', header: '計量日'},
                        {binding: '部門', header: '部門'},
                        {binding: '対象', header: '対象'},
                        {binding: 'カゴ車', header: 'カゴ車'},
                        {binding: '粗重量', header: '粗重量', format: 'n2', aggregate: 'Sum'},
                        {binding: '重量', header: '重量', format: 'n2', aggregate: 'Sum'},
                        {binding: 'メモ', header: 'メモ'},
                    ],
                    columnFields:['部門','対象'],
                    rowFields: ['計量日'],
                    valueFields: ['重量']
                }
            );
        })
    }

    onChangeFromDate(): void {
        this.toDateInput.min = this.fromDate;
    }

    export(grid: string, name: string) {
        if (this[grid] instanceof wjOlap.PivotGrid)
            wjcGridXlsx.FlexGridXlsxConverter.saveAsync(this[grid] as wjOlap.PivotGrid, {
                includeColumnHeaders: true,
                includeRowHeaders: true,
                includeCellStyles: false
            }, name + '.xlsx');
    }

}

